(function ($) {
    'use strict';

    //
    // Prevents the element(s) from propogating scroll events to the parent when they've reached the end of their scrollable content.
    // This way when scrolling in a panel\child and you keep mouse-wheeling the parent won't start to scroll behind it, which is usually
    // not what would be intended.
    //
    function preventScrollPropogation() {

        // 'mousewheel' event from the jquery.mousewheel.js plugin.
        this.on("mousewheel", function (event) {

            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.innerHeight(),
                delta = event.deltaY * event.deltaFactor,
                up = delta > 0;

            function prevent() {
                event.stopPropagation();
                event.preventDefault();
                event.returnValue = false;
                return false;
            }

            // Scrolling down, but this will take us past the bottom.
            if (!up && -delta > scrollHeight - height - scrollTop) {
                $this.scrollTop(scrollHeight);
                return prevent();
            }

            // Scrolling up, but this will take us past the top.
            else if (up && delta > scrollTop) {
                $this.scrollTop(0);
                return prevent();
            }
        });
    }

    jQuery.fn.extend({ preventScrollPropogation });

}) (jQuery);
